import type { IntlConfig } from 'react-intl'
import { ReactIntlErrorCode } from 'react-intl'

/**
 * EWM-1026: react-intl's default `onError` logs a formatting failure and then renders the raw
 * pattern, so a message called without its interpolation values ships `Assumptions ({count})`
 * to the user - that is exactly what reached a customer in EWM-1010.
 *
 * Nothing else catches it. `useMessages` types every message as `(params?: Record<string,
 * string>) => string` regardless of the string behind it, so omitting a required param, or
 * typo'ing one, compiles clean and renders a component that looks fine in review.
 *
 * FORMAT_ERROR (a missing or invalid interpolation value) is always a defect, so it throws in
 * dev and test - a red test, or a loud crash while the call site is still being written.
 * MISSING_TRANSLATION keeps the default logging everywhere: a sparse catalogue falling back to
 * `defaultMessage` is by design here, not a bug.
 *
 * Production behaviour is unchanged - a broken tooltip must not white-screen a customer.
 */
export const intlOnError: NonNullable<IntlConfig['onError']> = (error) => {
  if (import.meta.env.DEV && error.code === ReactIntlErrorCode.FORMAT_ERROR) {
    throw error
  }
  console.error(error)
}
